import ScheduleCancel from '../../cancel/cancel'

export default {
  ScheduleCancel
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/schedule/resources/components.js